<template>
  <div class="c-sidebar c-sidebar--menu collapse" v-bind:class="{ show: showMenu }" id="sidebar">
    <div class="c-sidebar__inner">
      <div class="c-sidebar__content">
        <b-nav vertical class="c-menu">
          <b-nav-item @click="onNavItemClicked" class="c-menu__item c-menu__item--level1" link-classes="c-menu__item-row" to="/dashboard" exact-active-class="is-active" exact>
            <strong>{{ $t("lang.label_certificate_dashboard") }} </strong>
          </b-nav-item>
          <b-nav-item @click="onNavItemClicked" class="c-menu__item c-menu__item--level1" link-classes="c-menu__item-row" to="/certificates" exact-active-class="is-active" exact>
            <strong>{{ $t("lang.label_certificate_myCerts") }} </strong>
          </b-nav-item>
          <b-nav-item @click="createCertificate" class="c-menu__item c-menu__item--level1" link-classes="c-menu__item-row" exact-active-class="is-active" exact>
            <strong>{{ $t("lang.label_certificate_createCert") }} </strong>
          </b-nav-item>
          <b-nav-item @click="onNavItemClicked" class="c-menu__item c-menu__item--level1" link-classes="c-menu__item-row" to="/ca-certificates" exact-active-class="is-active" exact>
            <strong>{{ $t("lang.label_caCert") }}</strong>
          </b-nav-item>
          <b-nav-item @click="onNavItemClicked" class="c-menu__item c-menu__item--level1" link-classes="c-menu__item-row" to="/quantum-safe-apps" exact-active-class="is-active" exact>
            <strong>{{ $t("lang.label_quantumSafeApps") }}</strong>
          </b-nav-item>
          <b-nav-item @click="onNavItemClicked" class="c-menu__item c-menu__item--level1" link-classes="c-menu__item-row" to="/user-profile" exact-active-class="is-active" exact>
            <strong>{{ $t("lang.label_profile") }}</strong>
          </b-nav-item>
          <b-nav-item @click="onNavItemClicked" class="c-menu__item c-menu__item--level1" link-classes="c-menu__item-row" to="/contact" exact-active-class="is-active" exact>
            <strong>{{ $t("lang.label_contact") }}</strong>
          </b-nav-item>
          <b-nav-item class="c-menu__item c-menu__item--level1 mt-5" link-classes="c-menu__item-row" @click="userLogout()">
            <strong>{{ $t("lang.label_logout") }}</strong>
          </b-nav-item>
        </b-nav>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SideMenu",
  props: {
    showMenu: Boolean
  },
  data() {
    return {};
  },
  components: {},
  computed: {
    statistics() {
      return this.$store.getters["certificate/certificateStatistics"]; // we need to get statistics for Issued Certificates
    }
  },
  methods: {
    onNavItemClicked() {
      this.$emit("update:show-menu", false);
    },
    createCertificate() {
      const issuedCerts = this.statistics.data.certsIssued;
      if (issuedCerts.issued === issuedCerts.max) {
        this.$bvModal.show("modal-noIssuedCerts");
      } else {
        this.$router.push({ name: "certificate-create" });
      }
      this.$emit("update:show-menu", false);
    },
    userLogout() {
      this.$emit("update:show-menu", false);
      this.$store.dispatch("auth/logout");
    }
  }
};
</script>
<style scoped></style>
